import { render, staticRenderFns } from "./AppDocumentation.vue?vue&type=template&id=e446b54c&"
import script from "./AppDocumentation.vue?vue&type=script&lang=js&"
export * from "./AppDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./AppDocumentation.vue?vue&type=style&index=0&id=e446b54c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports